import Table from "components/Table";
import { useMemo, useEffect } from "react";
import { useMap } from "context/mapContext";
import { useLoading, handleLoading } from "context/LoadingContext";
import getEsriDataFromLayer from "context/contextFunctions/getEsriDataFromLayer";
import PolesReportFilter from "./PolesReportFilter";

const neededDomains = ["Status", "Category"];

export default function PolesReport() {
  const [map, dispatchMap] = useMap();
  const [, dispatchLoading] = useLoading();
  const { view, polesLayer, polesReportList } = map;

  const headers = useMemo(
    () => [
      {
        accessorKey: "Point_ID",
        header: "Pole ID",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Category",
        header: "Category",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Governorate",
        header: "Governorate",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Municipality",
        header: "Municipality",
        enableColumnFilter: false,
      },
      {
        accessorKey: "StatusName",
        header: "Status",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Fail_Reason",
        header: "Fail Reason",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Easting",
        header: "X",
        enableColumnFilter: false,
        // cell: (param) => param.cell.row.original.LONGITUDE?.toFixed(6),
      },
      {
        accessorKey: "Northing",
        header: "Y",
        enableColumnFilter: false,
        // cell: (param) => param.cell.row.original.LATITUDE?.toFixed(6),
      },
      {
        accessorKey: "Installation_Date",
        header: "Installation Date",
        enableColumnFilter: false,
        cell: (param) => param.cell.row.original.Installation_Date_ISO,
      },
    ],
    []
  );

  const exportHeaders = useMemo(
    () => [
      {
        key: "Point_ID",
        label: "Pole ID",
      },
      {
        key: "Category",
        label: "Category",
      },
      {
        key: "Governorate",
        label: "Governorate",
      },
      {
        key: "Municipality",
        label: "Municipality",
      },
      {
        key: "StatusName",
        label: "Status",
      },
      {
        key: "Fail_Reason",
        label: "Fail Reason",
      },
      {
        key: "Easting",
        label: "X",
      },
      {
        key: "Northing",
        label: "Y",
      },
      {
        key: "Installation_Date_ISO",
        label: "Installation Date",
      },
    ],
    []
  );

  useEffect(() => {
    (async () => {
      handleLoading(dispatchLoading, true);
      try {
        const token = localStorage.getItem("token");
        const orderByFields = ["Installation_Date DESC"];
        if (polesLayer && view && token) {
          const {
            res: polesRes,
            domains: polesDomains,
            fields: polesFields,
          } = await getEsriDataFromLayer({
            featureLayer: polesLayer,
            orderByFields,
            neededDomains,
          });

          dispatchMap({
            type: "INIT",
            payload: {
              polesDomains,
              polesFields,
              polesReportList: polesRes.map((item) => ({
                ...item,
                StatusName: item.StatusName
                  ? item.StatusName
                  : "بانتظار التركيب",
              })),
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
      handleLoading(dispatchLoading, false);
    })();
  }, [view, polesLayer]);

  return (
    <div>
      <PolesReportFilter />
      <Table
        columns={headers}
        data={polesReportList}
        exportName={`Poles-Report-${new Date().toISOString().split("T")[0]}`}
        exportColumns={exportHeaders}
      />
    </div>
  );
}
